module.exports = __webpack_public_path__ + "img/bh_4.bb51da37.jpg";